/* eslint-disable @tencent/i18next/no-literal-string */
import React from 'react';
import { Score } from '@src/slide/application/service/slide-rating-and-improve/view/common/score/score';
import {
    AnalyzerResultType,
    IAnalyzerResult,
} from '@src/slide/application/service/slide-rating-and-improve/slide-content-analyzer.interface';
import type {
    SlideContentAnalyzer,
} from '@src/slide/application/service/slide-rating-and-improve/slide-content-analyzer';
import { Collapse, List } from 'tdesign-react';
import 'tdesign-react/es/style/index.css';
import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import Style from './result.less';
import TrueImage from './true.svg';
import FalseImage from './false.svg';
import i18n from '@i18next/i18n';
import { openUrlForAll } from '@src/slide/infrastructure/module/independent/url/open-url';
import { shouldDisableNetwork } from '@src/slide/infrastructure/module/dependent/socket';
import { getCacConfigByKey } from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import {
    IElementBaseModel,
} from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';

const { Panel } = Collapse;
const { ListItem } = List;

export interface RatingResultViewProps {
    analyzer: SlideContentAnalyzer;
    selectionService: ISelectionService;
}

export class RatingResultView extends React.Component<RatingResultViewProps> {
    public render() {
        const dataSource = this.getDataSource();
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    margin: '0px 16px',
                    padding: '16px',
                    borderRadius: '4px',
                    background: '#F9FAFB',
                }}>
                    <div style={{ width: '112px' }}>
                        <div className={Style['rating-result-title']}>
                            {i18n.t('最后得分')}
                        </div>
                        <div className={Style['rating-result-title-description']}>
                            { this.renderScoreDescription() }
                        </div>
                    </div>
                    <div style={{ position: 'relative', left: '20px' }}>
                        <Score score={this.props.analyzer.score}/>
                    </div>
                </div>
                <div style={{
                    height: '100%',
                    marginTop: '20px',
                    position: 'relative',
                    marginRight: '16px',
                    marginLeft: '16px',
                }}>
                    <div style={{
                        position: 'relative',
                        inset: 0,
                        overflowY: 'auto',
                        overflowX: 'hidden',
                    }}>
                        <Collapse
                            expandMutex
                            borderless
                            expandIcon={false}
                        >
                            {
                                dataSource.map((result, index) => this.renderCollapseItem(result, index))
                            }
                            {/* {*/}
                            {/*    this.renderPageStructInfo()*/}
                            {/* }*/}
                        </Collapse>
                    </div>
                </div>
                {this.showRatingAndImprove() && <div
                    style={{
                        height: '50px',
                        position: 'relative',
                        paddingTop: '32px',
                        fontSize: '12px',
                        textAlign: 'center',
                        color: 'rgba(0, 0, 0, 0.48)',
                    }}
                >
                    {i18n.t('评分不准？')}
                    <span style={{
                        color: '#175ceb',
                        cursor: 'pointer',
                        textDecoration: 'underline',
                    }}
                    onClick={() => {
                        const options = {
                            url: 'https://docs.qq.com/form/page/DZU50akpzWENrbW5w',
                            replace: false,
                            windowName: '_blank',
                        };
                        openUrlForAll(options);
                    }}
                    >
                        {i18n.t('帮助我们提升')}
                    </span>
                </div>}
            </div>
        );
    }

    private renderCollapseItem = (item: IAnalyzerResult, index: number) => {
        const success = item.resultType === AnalyzerResultType.SUCCESS;
        if (!success) {
            return <Panel
                style={{
                    borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
                }}
                value={`fail-${index}`}
                header={this.renderItemHeader(item)}
            >
                { this.renderFailDescription(item) }
            </Panel>;
        }
        return <Panel
            style={{
                borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
            }}
            value={`success-${index}`}
            header={this.renderItemHeader(item)}
            disabled
        />;
    };

    private renderItemHeader(item: IAnalyzerResult): React.ReactNode {
        const success = item.resultType === AnalyzerResultType.SUCCESS;
        return <div style={{
            position: 'relative',
            left: '-16px',
            display: 'flex',
            flexDirection: 'row',
        }}>
            <div>
                { this.renderItemAvatar(item) }
            </div>
            <div style={{
                position: 'relative',
                left: '10px',
            }}>
                <div className={Style['rating-result-item-title']}>
                    { item.analyzerName }
                </div>
                <div className={Style['rating-result-item-description']}>
                    { item.description }
                </div>
                {
                    !success && item.handleProblem && !this.hideSsvEntrance()
                    && <button
                        className={Style['rating-result-item-handle']}
                        onClick={
                            this.onCollapseItemClick.bind(this, item)
                        }
                    >
                        {i18n.t('去优化')}
                    </button>
                }
            </div>
        </div>;
    }

    private renderItemAvatar(item: IAnalyzerResult): React.ReactNode {
        if (item.resultType === AnalyzerResultType.SUCCESS) {
            return (
                <div style={{
                    height: '100%',
                }}>
                    <img className={Style['rating-result-item-img-true']} src={TrueImage} />
                </div>
            );
        }
        return (
            <div style={{
                height: '100%',
            }}>
                <img className={Style['rating-result-item-img-false']} src={FalseImage} />
            </div>
        );
    }

    private renderFailDescription(item: IAnalyzerResult): React.ReactNode {
        return <List
            size='small'
            style={{
                position: 'relative',
                width: 'calc(100% + 30px)',
                left: '-15px',
                top: '-15px',
                marginBottom: '-18px',
            }}
        >
            {
                item.getDescriptionWithSelect()?.map((current, index) => (
                    <ListItem
                        style={{ paddingLeft: '0px', paddingRight: '0px' }}
                        action={
                            current.selectElement && <button
                                className={Style['rating-result-list-item-handle']}
                                onClick={
                                    () => {
                                        if (current.selectSlide?.sdkData && current.selectElement?.sdkData) {
                                            this.selectSlideAndElement(current.selectSlide, current.selectElement);
                                        }
                                        if (current.handleProblem) {
                                            current.handleProblem(index);
                                            this.refresh(item);
                                            return;
                                        }
                                    }
                                }
                            >
                                {i18n.t('去处理')}
                            </button>
                        } key={index}
                    >
                        <div className={Style['rating-result-list-item-description']}
                            style={{ cursor: current.selectable ? 'pointer' : 'default' }}
                            onClick={() => {
                                if (current.selectSlide && current.selectElement) {
                                    this.selectSlideAndElement(current.selectSlide, current.selectElement);
                                }
                            }}
                        >
                            {current.description}
                        </div>
                    </ListItem>
                ))
            }
        </List>;
    }

    private selectSlideAndElement(toSelectSlide: ISlideModel, toSelectElement: IElementBaseModel) {
        this.props.selectionService.selectedSlides.clear();
        const slideIndex = toSelectSlide
            .presentationRef?.indexOfSlide(toSelectSlide);
        if (slideIndex !== undefined && slideIndex !== -1) {
            const element = toSelectElement;
            this.props.selectionService.currentSlideIndex = slideIndex;
            setTimeout(() => {
                this.props.selectionService.selectedElements.clear();
                this.props.selectionService.selectedElements.add(element);
            });
        }
    }

    private onCollapseItemClick(item: IAnalyzerResult, event) {
        event?.preventDefault?.();
        event?.stopPropagation?.();
        item.handleProblem?.(() => {
            item.resultType = AnalyzerResultType.SUCCESS;
            this.refresh(item);
        });
    }

    private refresh = (item: IAnalyzerResult) => {
        if (item.resultType === AnalyzerResultType.SUCCESS) {
            this.props.analyzer.calculateScore();
        }
        this.setState({});
    };

    private getDataSource(): Array<IAnalyzerResult> {
        const { fontUseNumberResult } = this.props.analyzer.textAnalyzer;
        if (!fontUseNumberResult) return []; // 理论上不存在
        return [
            this.props.analyzer.textAnalyzer.titleFontSizeResult,
            this.props.analyzer.textAnalyzer.subTitleFontSizeResult,
            this.props.analyzer.textAnalyzer.lineSpacingResult,
            fontUseNumberResult,
            this.props.analyzer.textAnalyzer.textOverlapResult,
            this.props.analyzer.colorAnalyzer.textColorContrastResult,
            this.props.analyzer.titleAlignmentResult,
        ];
    }

    private renderScoreDescription() {
        const { score } = this.props.analyzer;
        if (score >= 90) return i18n.t('检测到你的幻灯片非常棒！');
        if (score >= 60) return i18n.t('检测到你的幻灯片有点小问题');
        return i18n.t('检测到你的幻灯片有些问题');
    }

    /**
     * 是否展示帮助提升跳转入口
     * 禁用网络连接功能时，同时屏蔽向 form 品类的跳转
     * @returns
     */
    private showRatingAndImprove() {
        return !shouldDisableNetwork();
    }

    /**
     * 是否屏蔽vip功能入口
     * 字体批量调整等 '去优化'入口
     * @returns
     */
    private hideSsvEntrance() {
        return getCacConfigByKey('custom.common.hideSsv', false);
    }
}
